module.exports = __webpack_public_path__ + "media/store/fonts/Adam-Regular-5983b30f6815eca85a37b044e1bb4026.otf";